
      import {$emit} from 'uni-platform/service/api/base/event-bus.js'
import {$off} from 'uni-platform/service/api/base/event-bus.js'
import {$on} from 'uni-platform/service/api/base/event-bus.js'
import {$once} from 'uni-platform/service/api/base/event-bus.js'
import {canIUse} from 'uni-core/service/api/base/can-i-use.js'
import {chooseImage} from 'uni-platform/service/api/media/choose-image.js'
import {clearStorageSync} from 'uni-platform/service/api/storage/storage.js'
import {createAnimation} from 'uni-core/service/api/ui/create-animation.js'
import {createCanvasContext} from 'uni-core/service/api/context/canvas.js'
import {createIntersectionObserver} from 'uni-core/service/api/ui/create-intersection-observer.js'
import {createMediaQueryObserver} from 'uni-core/service/api/ui/create-media-query-observer.js'
import {createSelectorQuery} from 'uni-core/service/api/ui/create-selector-query.js'
import {downloadFile} from 'uni-platform/service/api/network/download-file.js'
import {getImageInfo} from 'uni-platform/service/api/media/get-image-info.js'
import {getLocale} from 'uni-core/service/api/ui/locale.js'
import {getLocation} from 'uni-platform/service/api/location/get-location.js'
import {request} from 'uni-platform/service/api/network/request.js'
import {getNetworkType} from 'uni-platform/service/api/device/network-info.js'
import {getStorageInfoSync} from 'uni-platform/service/api/storage/storage.js'
import {getStorageSync} from 'uni-platform/service/api/storage/storage.js'
import {getSystemInfo} from 'uni-platform/service/api/device/get-system-info.js'
import {getSystemInfoSync} from 'uni-platform/service/api/device/get-system-info.js'
import {hideKeyboard} from 'uni-platform/service/api/keyboard/keyboard.js'
import {hideLoading} from 'uni-platform/service/api/ui/popup.js'
import {hideToast} from 'uni-platform/service/api/ui/popup.js'
import {makePhoneCall} from 'uni-platform/service/api/device/make-phone-call.js'
import {navigateBack} from 'uni-platform/service/api/route/route.js'
import {navigateTo} from 'uni-platform/service/api/route/route.js'
import {pageScrollTo} from 'uni-core/service/api/ui/page-scroll-to.js'
import {preloadPage} from 'uni-platform/service/api/route/route.js'
import {previewImage} from 'uni-platform/service/api/media/preview-image.js'
import {reLaunch} from 'uni-platform/service/api/route/route.js'
import {redirectTo} from 'uni-platform/service/api/route/route.js'
import {removeStorageSync} from 'uni-platform/service/api/storage/storage.js'
import {setNavigationBarColor} from 'uni-platform/service/api/ui/navigation-bar.js'
import {setNavigationBarTitle} from 'uni-platform/service/api/ui/navigation-bar.js'
import {setStorageSync} from 'uni-platform/service/api/storage/storage.js'
import {showLoading} from 'uni-platform/service/api/ui/popup.js'
import {showModal} from 'uni-platform/service/api/ui/popup.js'
import {showToast} from 'uni-platform/service/api/ui/popup.js'
import {stopPullDownRefresh} from 'uni-platform/service/api/ui/pull-down-refresh.js'
import {switchTab} from 'uni-platform/service/api/route/route.js'
import {upx2px} from 'uni-core/service/api/base/upx2px.js'
      export default {
        $emit,
$off,
$on,
$once,
canIUse,
chooseImage,
clearStorageSync,
createAnimation,
createCanvasContext,
createIntersectionObserver,
createMediaQueryObserver,
createSelectorQuery,
downloadFile,
getImageInfo,
getLocale,
getLocation,
request,
getNetworkType,
getStorageInfoSync,
getStorageSync,
getSystemInfo,
getSystemInfoSync,
hideKeyboard,
hideLoading,
hideToast,
makePhoneCall,
navigateBack,
navigateTo,
pageScrollTo,
preloadPage,
previewImage,
reLaunch,
redirectTo,
removeStorageSync,
setNavigationBarColor,
setNavigationBarTitle,
setStorageSync,
showLoading,
showModal,
showToast,
stopPullDownRefresh,
switchTab,
upx2px
      }
      